import React from "react";
import { ReactComponent as SofaIcon } from "../../../../assets/svg/sofa.svg";

export function Sofa() {
  return <SofaIcon fill="var(--black)" />;
}
